import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 5V12M12 12V19M12 12H19M12 12H5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgPlus;
